// deno-lint-ignore-file no-explicit-any
import { IS_BROWSER } from '$fresh/runtime.ts'
import { signal } from '@preact/signals'

type Props = {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    onError?: (event: any) => void
    onSpeech?: () => void
}

export function useSpeechRecognition({ onError, onSpeech }: Props = {}) {
    const isListening = signal(false)
    const detectedText = signal('')

    if (!IS_BROWSER || !('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) {
        return {
            detectedText,
            isListening,
            start: () => {},
            stop: () => {},
            supported: false,
        }
    }

    // @ts-ignore dont have types on vscode
    const recognition = new webkitSpeechRecognition() || SpeechRecognition()

    recognition.onstart = () => {
        isListening.value = true
    }

    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    recognition.onerror = (e: any) => {
        isListening.value = false
        onError?.(e)
    }

    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    recognition.onresult = (event: any) => {
        isListening.value = false
        detectedText.value = event.results?.[0]?.[0].transcript ?? ''
        onSpeech?.()
    }

    recognition.onspeechend = () => {
        isListening.value = false
    }

    const start = () => {
        if (!isListening.value) {
            recognition.start()
        }
    }

    const stop = () => {
        if (isListening.value) {
            recognition.stop()
        }
    }

    return {
        supported: 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window,
        detectedText,
        isListening,
        start,
        stop,
    }
}
